import React from "react";
import styles from "./Destinations10.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations10 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Duplicate array for seamless infinite scrolling
  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            Travel <span>Memories</span>
          </h2>
          <p className={styles.lead}>
            Captured moments from around the globe
          </p>
        </div>

        <div className={styles.trackWrapper}>
          <div className={styles.track}>
            {scrollItems.map((dest, index) => {

              const fallbackImage =
                fallbackImages[index % fallbackImages.length];

              const imageUrl =
                dest?.image && dest.image.trim() !== ""
                  ? dest.image
                  : fallbackImage;

              return (
                <div key={index} className={styles.card}>
                  <div className={styles.polaroid}>
                    <div className={styles.imageArea}>
                      <img
                        src={imageUrl}
                        alt={dest?.name || "Destination"}
                        className={styles.image}
                        onError={(e) => {
                          e.target.src = fallbackImage;
                        }}
                      />

                      <div className={styles.tape}></div>
                    </div>

                    <div className={styles.caption}>
                      <h3 className={styles.cardTitle}>
                        {dest?.name || "Explore Destination"}
                      </h3>

                      <span className={styles.date}>
                        Summer '24
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Destinations10;